import React from 'react';
import { createUseStyles } from 'react-jss';
import KeyValue from './KeyValue';
import { Button } from 'primereact/button';
import useMobileHandler from '../hooks/useMobileHandler';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

function SearchResultFibra({ result,leadId, onCompanySelected }) {

    const mobileHandler = useMobileHandler();

    const st = styles();


    if (mobileHandler.isMobile)
        return (
            <div className='flex flex-column resultItemContainer mb-3 l	'>
                <div className=' mz_center '>{result.nome}</div>
                <div className='resultItemInnerContainer pb-3'>

                    <div className='flex flex-row justify-content-between p-2	'>
                        <div className=''>
                            <img className='logo_azienda_mobile' src={result.url_immagine} ></img>

                        </div>
                        <div >
                            <div className='textBold font14'>Prezzo/Mese</div>
                            <div className='textLinethrough' >{result.prezzo_base}</div>
                            <div className='textPromo' >{result.prezzo_promo} €</div>
                        </div>
                    </div>
                    <div>
                        <div className='mt-1 pl-4 '>
                            <KeyValue key1={"Operatore:"} value={result.azienda} />
                            <KeyValue key1={"Offerta:"} value={result.nome} />
                            <KeyValue key1={"Attivazione:"} value={result.costo_attivazione + " €"} />
                            <KeyValue key1={"Velocità:"} value={result.velocita_download_in_mbs + " Mbit/s"} />
                            <KeyValue key1={"Costo Modem:"} value={result.costo_modem + " €"} />
                            <KeyValue key1={"Vincolo:"} value={result.vincoli} />
                        </div>
                    </div>
                    <div className=' flex justify-content-center mt-3'>
                        <Button className='mz_fit_content paddingUnset shadow-4' style={{ width: "max-content" }} onClick={()=> onCompanySelected(leadId, result.id) }    >
                            <div className='flex flex-row ml-2 mr-2'  >
                                <img alt="logo" src={IMAGE_URL + "/robot-lia.png"} className="parla_ia  align-self-center"></img>
                                <div className='pl-2 mz_fit_content align-self-center'>Parla con Lia</div>
                                {/*<div className='mz_fit_content textSmall'>con un esperto</div>*/}
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        )



    return (
        <div className={"mb-2"}>

            <div className='resultItemContainer'>
                <div className='mz_fit_content mz_center '>{result.nome}</div>
                <div className='resultItemInnerContainer'>
                    <div className='grid'>
                        <div className='col-2'>
                            <img className='logo_azienda' src={result.url_immagine} ></img>
                        </div>
                        <div className='col-5 mt-1'>
                            <KeyValue key1={"Operatore:"} value={result.azienda} />
                            <KeyValue key1={"Offerta:"} value={result.nome} />
                            <KeyValue key1={"Attivazione:"} value={result.costo_attivazione + " €"} />
                            <KeyValue key1={"Velocità:"} value={result.velocita_download_in_mbs + " Mbit/s"} />
                            <KeyValue key1={"Costo Modem:"} value={result.costo_modem + " €"} />
                            <KeyValue key1={"Vincolo:"} value={result.vincoli} />
                        </div>


                        <div className='col-2 flex flex-column'>
                            <div className='textBold font14'>Prezzo/Mese</div>
                            <div className='textLinethrough' >{result.prezzo_base}</div>
                            <div className='textPromo' >{result.prezzo_promo} €</div>
                        </div>

                        <div className='col-3 flex justify-content-center mt-3'>
                            <Button className='mz_fit_content paddingUnset shadow-4' style={{ width: "max-content" }} onClick={()=> onCompanySelected(leadId, result.id_azienda) }     >
                                <div className='flex flex-column ml-2 mr-2'  >
                                    <img alt="logo" src={IMAGE_URL + "/robot-lia.png"} className="parla_ia  align-self-center"></img>
                                    <div className='mz_fit_content'>Parla con Lia</div>
                                    {/*<div className='mz_fit_content textSmall'>con un esperto</div>*/}
                                </div>
                            </Button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
}

const styles = createUseStyles({
    container: {

    }
});

export default SearchResultFibra;